<template>
    <div class="sh040" id="sh040">
        <loading :active.sync="isLoading" 
            :can-cancel="false"
            :background-color="'transparent'">
        </loading>
        <!-- ご注文手続き -->
        <div class="sh040-title">
            <h2>{{$t("sh030.labels.orderProcedure")}}</h2>
        </div>

        <div class="section-inner sh040-body">
            <!--お気に入りタイトル-->
            <div class="sh040-body-title">
                <h4>お届け先の選択</h4>
                <span id="tdkCopyMsg"></span>
            </div>
            
            <div class="sh040MainArea">
                <!-- 【注文情報設定】第一行（お届け先情報、お届け希望日時、ギフト設定） -->
                <div class="sh040MainAreaRow">
                    <template v-for="(item, index) in pt440Init.multTdksInfo"  >
                        <!-- お届け先情報 -->
                        <div class="sh040MainAreaRowOfOne" v-bind:key="index" >
                            <div class="sh040MainAreaRowOfOneCard">
                                    <div class="sh040MainAreaRowOfOneCardHead" >
                                        <div class="sh040MainAreaRowOfOneCardHeadTitle">
                                            <span v-if="item.TDK_M_SEQ ==0 && pt440Init.siteFlg == 0" class="h3 bg-primary text-white">本人</span>
                                            <span v-else-if="item.TDK_M_SEQ ==0 && pt440Init.siteFlg == 1" class="h3 bg-primary text-white">自社</span>
                                        </div>
                                        <div class="sh040MainAreaRowOfOneCardHeadCheck1">
                                            <input type="checkbox" :id="'tdkNoCheckBox' + index" name="tdkNoCheckBox" :true-value="item.TDK_M_SEQ" :false-value="-1" v-model="pt440ReqModel.tdkNoCheckBox[index]" @click="setTdkNoCheckBox(index)">
                                        </div>
                                    </div>
                                    <div class="sh040MainAreaRowOfOneCardBody" >
                                        <h5 class="sh040MainAreaRowOfOneCardBodyContents">{{item.TDK_NM1}}&nbsp;{{item.TDK_NM2}}&nbsp;{{item.TDK_NM3}}</h5>
                                        <h5 class="sh040MainAreaRowOfOneCardBodyContents">{{item.TDK_ZIP}}</h5>
                                        <h5 class="sh040MainAreaRowOfOneCardBodyContents">{{item.TDK_ADDR1}}{{item.TDK_ADDR2}}{{item.TDK_ADDR3}}</h5>
                                        <h5 class="sh040MainAreaRowOfOneCardBodyContents">{{item.TDK_TEL1}}</h5>
                                    </div>
                                    <div class="sh040MainAreaRowOfOneCardHead" v-if="pt440Init.seikyudoukonOption == 1 && pt440Init.siteSeikyudoukonOption == 1 " >
                                        <div class="sh040MainAreaRowOfOneCardHeadTitle"></div>
                                        <div class="sh040MainAreaRowOfOneCardHeadCheckBottom">
                                            <input type="hidden" :id="'seikyuDoukonFlgHidden'+index" v-model="pt440ReqModel.seikyuDoukonFlg[index]">
                                            <label :for="'seikyuDoukonFlg'+index" v-if="pt440ReqModel.tdkNoCheckBox[index] !== -1" >
                                                <input type="checkbox" :id="'seikyuDoukonFlg'+index" name="seikyuDoukonFlg" :true-value="1" :false-value="0" v-model="pt440ReqModel.seikyuDoukonFlg[index]" class="margin-left-10px" @click="setSeikyuDoukonFlg(index)">
                                                <span>{{$t("sh030.labels.seikyuDoukonFlg")}}</span>
                                            </label>
                                        </div>
                                    </div>
                            </div>
                        </div>
                    </template>
                    <!-- お届け先情報(追加) -->
                    <div class="sh040MainAreaRowOfOneAdd">
                        <div class="sh040MainAreaRowOfOneCardAdd">
                                <div class="sh040MainAreaRowOfOneCardBodyAdd" >
                                    <div >
                                    <a href="javascript:void(0)" @click="backUrl(78);">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="45px" height="45px" fill="currentColor" class="bi bi-plus-circle" viewBox="0 0 16 16">
                                        <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"/>
                                        <path d="M8 4a.5.5 0 0 1 .5.5v3h3a.5.5 0 0 1 0 1h-3v3a.5.5 0 0 1-1 0v-3h-3a.5.5 0 0 1 0-1h3v-3A.5.5 0 0 1 8 4z"/>
                                    </svg>
                                    <div id="tdkTuikaCopyMsg" class="sh040MainAreaRowOfOneCardBodyAddTitle">お届け先追加</div></a></div>
                                </div>
                        </div>
                    </div>
                </div>
            </div>
     
            <!--戻るボタン-->
            <div id="btn_roll2" >
                <a class="btnSubmit" @click="backUrl(22)">{{$t('sh040.buttons.backtothepreviouspage')}}</a>
                &nbsp;
                <a class="btnSubmit" @click="confirmOrder()">{{$t('sh040.buttons.update')}}</a>
            </div>
        </div>
        <!-- modal confirm area -->
        <alert-confirm
            v-if="isModalShow"
            :msgConfirm="msgConfirm"
            :isButtonCancel="false"
        >
        </alert-confirm>
        <COLOR_SIZE v-if="colorSizeFlg" :data="dataColorSize" @modal-close="colorSizeFlg = false" @set-addr-value="setValue"></COLOR_SIZE>
    </div>
</template>

<script>
/*
* Import libs and componnents
*/
import axios from "assets/js/request";
import common from 'assets/js/common';
import PageFeed from "../commonParts/PageFeed";
import SiteConstants from 'assets/const/SiteConstants.json';
import InputNumber from 'components/InputNumber';
import Breadcrumb from "../commonParts/Breadcrumb.vue";
import AlertConfirm from 'components/AlertConfirm';
import EventBus from 'assets/js/eventBus';
import toastr from "toastr/toastr.js";
import "toastr/build/toastr.min.css";
import COLOR_SIZE from '../parts/PT110_colorSizeModal.vue';
import Loading from 'vue-loading-overlay';

toastr.options = {
  closeButton: true,
  positionClass: "toast-top-right",
  showDuration: "300",
  hideDuration: "1000",
  timeOut: "2000",
};

export default {
    /*
    * Name of component
    */
    name: "pt440",
    /* 
    * Declare components
    */
    components: {
        PageFeed,
        InputNumber,
        Breadcrumb,
        AlertConfirm,
        EventBus,
        toastr,
        COLOR_SIZE,
        Loading
    },
    /*
    * Declare props
    */
    props: {
        ptPageNo: {
            type: [Number,String]
        },
        ptPageSize: {
            type: [Number,String]
        },
        ptOrderByType: {
            type: [Number,String]
        },
        ptInitData: {
            type: Object,
            default: null,
        }
    },
    /*
    * Declare variable and set default value
    */
    data: function() {
        return {
            isDisplay: false,
            isPagingDisplay: false,
            isModalShow:false,
            isSortDisp: false,
            msgConfirm:'',
            tdkNoCheckBox:[],
            seikyuDoukonFlg: [],
            seikyuDoukonFlgIdx : 0,
            pt440ReqModel: {
                tdkNoCheckBox: [],
                seikyuDoukonFlg: [],
                sItemNo: null,
                orderType: 0,
                totalRecord: null,
                fromRecord: null,
                toRecord: null,
                pageSize: this.ptPageSize != undefined ? this.ptPageSize : 16,
                pageNo: this.ptPageNo != undefined ? this.ptPageNo : 1
            },
            pt440Init: {
                pageNo: null,
                pageSize: null,
                favouriteList: {},
                backButtonFlg: 0
            },
            favouriteSortKbnList: [],
            pt440Valid: {},
            queryData: null,
            pageFeedData: {
                totalRecord: 50,
                fromRecord: 1,
                toRecord: 10,
                pageSize: 16,
                pageNo: 1
            },
            dispPageSizeList:[],
            SiteConstants: SiteConstants,
            site: "",
            colorSizeFlg : false,
            colorSizeModal:{
                colSizList : []
            },
            dataColorSize:{},
            isLoading: false,
        }
    },
    /*
    * 初期処理
    */
    mounted: function() {
        var _this = this;
        _this.site = _this.$router.history.current.fullPath.split("/")[1];

        if (_this.ptInitData){
            // 未ログインの場合はログイン画面へ
            if(_this.ptInitData.isLogin == false) {
                _this.$router.push({ name: _this.SiteConstants.PG010MAIN, query: { pageNo: 18, returnFlg:1, fromCart:1}});
            } else {
                _this.pt440Init = _this.ptInitData;
                _this.getDataForPageFeed(_this.ptInitData);
                _this.dispPageSizeList = _this.pt440Init.pageSizeList;
                _this.favouriteSortKbnList = _this.pt440Init.favouriteSortKbnList;
                if (_this.favouriteSortKbnList != null && _this.favouriteSortKbnList.length > 0) {
                    _this.isSortDisp = true;
                }
                for (var i = 0; i < _this.pt440Init.multTdksInfo.length ; i++ ) {
                    if (_this.pt440Init.multTdksInfo[i].TDK_PAGE_CHK !== -1)
                        _this.pt440ReqModel.tdkNoCheckBox[i] = _this.pt440Init.multTdksInfo[i].TDK_M_SEQ;
                    else
                        _this.pt440ReqModel.tdkNoCheckBox[i] = -1;
                    _this.pt440ReqModel.seikyuDoukonFlg[i] = _this.pt440Init.multTdksInfo[i].HARAIKOMI_DOUKON_FLG;
                }
            }
        }else{
            axios.post(_this.$UrlConstants.ECSITE + _this.$UrlConstants.SH040 + _this.$UrlConstants.DO_INIT, _this.pt440ReqModel).then(function(response) {
                // 未ログインの場合はログイン画面へ
                if(response.data.isLogin == false) {
                    _this.$router.push({ name: _this.SiteConstants.PG010MAIN, query: { pageNo: 18}});
                } else {
                    _this.pt440Init = response.data;
                    _this.getDataForPageFeed(response.data);
                    _this.dispPageSizeList = _this.pt440Init.pageSizeList;
                    _this.favouriteSortKbnList = _this.pt440Init.favouriteSortKbnList;
                    if (_this.favouriteSortKbnList != null && _this.favouriteSortKbnList.length > 0) {
                        _this.isSortDisp = true;
                    }
                    for (var i = 0; i < _this.pt440Init.multTdksInfo.length ; i++ ) {
                        if (_this.pt440Init.multTdksInfo[i].TDK_PAGE_CHK !== -1)
                            _this.pt440ReqModel.tdkNoCheckBox[i] = _this.pt440Init.multTdksInfo[i].TDK_M_SEQ;
                        else
                            _this.pt440ReqModel.tdkNoCheckBox[i] = -1;//カート分割対応
                    }
                }
            }).catch(function(error) {
                common.errorAPI(error);
            });
        }

        //POPUPを閉じる処理
        EventBus.$on('closed', function() {
            _this.isModalShow = false;
        });
    },
    /*
    * Methods
    */
    methods: {
        /**
         * カートに入れるボタン押下処理
         * @param {String} sItemNo, item product
         */
        doOrder : function() {
            var _this = this;
            axios.post(_this.$UrlConstants.ECSITE + _this.$UrlConstants.PT110 + _this.$UrlConstants.DO_AJAX, _this.pt440ReqModel).then(function(response) {
                var colorSizeList = response.data.colSizList;
                // カラーサイズリストが存在する場合に表示
                if (common.getLengthObj(colorSizeList) > 0 && colorSizeList[0].VALUE != undefined) {
                    
                    // カラーサイズ表示フラグON
                    _this.colorSizeFlg = true;
                    return;
                } else {
                    _this.doOrderConfirm();
                }
            }).catch(function(error) {
                if(error != null && error != undefined){
                    common.errorAPI(error);
                }
            });
        },
        doOrderConfirm : function () {
            var _this = this;
            _this.doConfirm().then(function() {
                if(!_this.pt440Valid.sellFlg) {
                    alert(_this.pt440Valid.warning);
                } else {
                    var message1 = _this.$i18n.t('pt120.labels.itemCntCheck[0]');
                    var message2 = _this.$i18n.t('pt120.labels.itemCntCheck[1]');
                    if(_this.pt440Valid.itemCheckFlg == 1 && _this.pt440Valid.itemCnt > 0) {
                        if (!confirm(message1 + "\n" + message2)) {
                            return;
                        }
                    }
                    _this.confirmOrder();
                }
            });
        },
        gotoSettingPage : function(nextPageId) {
            this.$router.push({ name: this.SiteConstants.PG010MAIN, query: {pageNo: nextPageId}});
        },
        /*
        * カラーサイズ商品コードセット
        */
        setValue(data){
            var _this = this;
            _this.pt440ReqModel.sItemNo = data.sItemNo;
            _this.doOrderConfirm();
        },
        /*
        * 戻るボタン押下処理
        */
        backUrl: function(pageId) {
            var _this = this;
            _this.$router.push({ name: _this.SiteConstants.PG010MAIN, query: {pageNo: pageId}, params:{motoPageId: 'sh040'}});
        },
        /*
        * 戻るボタン押下処理
        */
        tdkCkeckBoxClick: function(index, value) {
            var _this = this;
            var checkboxes = $("input[name=tdkNoCheckBox]");
            if (checkboxes[index].checked)
                _this.pt440ReqModel.tdkNoCheckBox[index] = value;
            else
                _this.pt440ReqModel.tdkNoCheckBox[index] = '-1';
        },
        setSeikyuDoukonFlg(index1) {
            this.pt440ReqModel.seikyuDoukonFlg = Array.from(Array($("input[name=tdkNoCheckBox]").length), () => 0);
            if ($( "#seikyuDoukonFlg" + index1 ).prop('checked')) {
                return;
            }
            $('input[name=seikyuDoukonFlg]').each(function(){
                $(this).prop('checked', false);
            });
        },
        setTdkNoCheckBox(index) {
            this.pt440ReqModel.seikyuDoukonFlg[index] = 0;
        },
        doDetail: function(sItemNo){
            var _this = this;
            _this.$emit("event-loading", true);
            var ptPageNo = _this.pt440ReqModel.pageNo;
            var ptPageSize = _this.pt440ReqModel.pageSize;
            _this.$router.push({ name: SiteConstants.PG030, params :{pageNo: 3, sItemNo: sItemNo, backPageNo: 7,ptPageNo: ptPageNo, ptPageSize: ptPageSize}});
        },
        /**
         * exec load url default when load main image is error
         * @param {Any} event, event exec error
         */
        getErrImage(event) {
            //get image default
            event.target.src = common.getImgDefault();
        },
        formatPrice: function(value){
            return common.formatPrice(value);
        },
        /**
         * get length a object
         * @param {Object} obj, object to get length
         */
        getLengthObj: function(obj) {
            if(obj != undefined)
            return common.getLengthObj(obj);
        },
        //Methods for pageFeed
        changeSearch: function(sortNo, pageSize, pageNo) {
            this.pt440ReqModel.pageSize = pageSize;
            this.pt440ReqModel.pageNo = pageNo;
            this.pt440ReqModel.orderType = sortNo;
            //var queryString = this.getQueryString(pageSize, 'ptPageSize');
            //location.href = process.env.VUE_APP_PUBLIC_PATH + this.$route.path + '?' + queryString;
        },
        /**
         * get page size, page no
         * @param {Number} val
         * @param {String} type
         */
        getQueryString: function(val, type){
            var query = this.$route.query;
            query.ptPageNo = this.pt440ReqModel.pageNo;
            query.ptPageSize = this.pt440ReqModel.pageSize;
            query.ptOrderByType = this.pt440ReqModel.orderType;
            query[type] = val;

            var queryString = "";
            var index= 0;
            for(var propertyName in query) {
                if(index == 0){
                    queryString += propertyName + '=' + query[propertyName];
                } else{
                    queryString += '&' + propertyName + '=' + query[propertyName];
                }
                index++;
            }
            return queryString;
        },
        /**
         * get data for page feed
         * @param {Object} data, data from API
         */
        getDataForPageFeed: function(data){
            var _this = this;
            _this.pageFeedData.totalRecord = data.totalRecord;
            _this.pageFeedData.fromRecord = data.fromRecord;
            _this.pageFeedData.toRecord = data.toRecord;
            _this.pageFeedData.pageSize = data.pageSize;
            _this.pageFeedData.pageNo = data.pageNo;

            if(_this.pt440Init.favouriteList && _this.pt440Init.favouriteList.length > 0){
                _this.isPagingDisplay = true;
            }else{
                _this.isPagingDisplay = false;
            }
        },

        doConfirm: function() {
            var _this = this;
            _this.$emit("event-loading", true);

            return axios.post(_this.$UrlConstants.ECSITE + _this.$UrlConstants.SH040 + _this.$UrlConstants.DO_CONFIRM, _this.pt440ReqModel)
            .then(function(response) {

                _this.$emit("event-loading", false);

                _this.pt440Valid = response.data;
            }).catch(function(error) {
                _this.$emit("event-loading", false);
                common.errorAPI(error);
				common.scrollTop();
            });
        },
        /*
        * カートに入れる処理
        */
        confirmOrder: function() {
            var _this = this;
            const isAllNotChecked = _this.pt440ReqModel.tdkNoCheckBox.every(item => item === -1);
            if (isAllNotChecked) {
                _this.msgConfirm = _this.$i18n.t('sh040.messages.tdkNoNotChecked')
                _this.isModalShow = true;
                return;
            }
            _this.$emit("event-loading", true);

            _this.pt440ReqModel.tdkMSeqs = Array.from(_this.pt440ReqModel.tdkNoCheckBox, (x) => (x == _this.pt440Init.multTdksInfo[0].TDK_M_SEQ) ? 0 : 1); 
            axios.post(_this.$UrlConstants.ECSITE + _this.$UrlConstants.SH040 + _this.$UrlConstants.DO_INSERT, _this.pt440ReqModel).then(function(response) {
                //PageNo:28 お届先振り分け設定画面へ
                _this.$router.push({ name: _this.SiteConstants.PG010MAIN, query: { pageNo: 28} , params:{motoPageId: 'sh060'}});
                _this.$emit("event-loading", false);
            }).catch(function(error) {
                _this.$emit("event-loading", false);
                if(error && error.response.status) {
                    var resultValid = common.excuteValidationEcSite(error);
                    if(resultValid) {
                        alert(resultValid.msgList);
                    }
                } else {
                    common.errorAPI(error);
                }
                common.scrollTop();
            });
        }
    },
    created(){
        this.queryData = this.$route.query;
        if(this.queryData != null){
            if(this.queryData.ptPageNo != null){
                this.pt440ReqModel.pageNo = this.queryData.ptPageNo;
            }
            if(this.queryData.ptPageSize != null){
                this.pt440ReqModel.pageSize = this.queryData.ptPageSize;
            }
            if(this.queryData.ptOrderByType != null){
                this.pt440ReqModel.orderType = this.queryData.ptOrderByType;
            }
        }
    },
    beforeDestroy() {
        EventBus.$off('closed');
        EventBus.$off('is-loading');
    }
}
</script>
